import React from 'react';
import './Loading.css';

const Loading = ({ message = 'Loading...' }) => {
    return (
        <div className="loading-container">
            <div className="loading-logo">
                <img
                    src="/assets/logos/getolli_icon.svg"
                    alt="Loading"
                    className="loading-icon"
                />
            </div>
            <p className="loading-message">{message}</p>
        </div>
    );
};

export default Loading;
